import { ref } from "vue";
import { getProtocolTextApi } from "@/api/protocolTextApi";

/**
 * 协议 TEXT 枚举翻译内存缓存（模块级 ref，全局共享）。
 *
 * <p>App 初始化时调 loadProtocolText 加载，页面展示工况/电池状态等枚举值时调
 * resolveProtocolText 翻译为当前语言文本。
 * 刷新浏览器/关闭重开都会重新加载（内存不持久）。
 * 协议项变更后刷新页面即可生效。</p>
 */

/** 协议 TEXT 映射 {dataId: ["中文|English", ...]} */
const protocolTextMap = ref<Record<string, string[]>>({});

/** 是否已加载过 */
let loaded = false;

/**
 * 加载协议 TEXT 映射到内存缓存
 */
export const loadProtocolText = async () => {
  const result = await getProtocolTextApi();
  if (result) {
    protocolTextMap.value = result;
    loaded = true;
  }
};

/**
 * 解析枚举值 -> 显示文本
 *
 * @param dataId  协议 data_id（如 20=runWork, 21=batSt）
 * @param value   终端上报的原始值（0, 1, 2...）
 * @param locale  当前语言 'zh' | 'en'
 * @returns 翻译后的显示文本，未命中返回原始值的字符串形式
 */
export const resolveProtocolText = (
  dataId: number,
  value: number | null | undefined,
  locale: string
): string => {
  if (value == null) return "-";
  const texts = protocolTextMap.value[String(dataId)];
  if (!texts || value < 0 || value >= texts.length) return String(value);
  const item = texts[value];
  const [zh, en] = item.split("|");
  return locale === "en" ? en ?? zh : zh;
};

/**
 * 协议 TEXT 映射是否已加载
 */
export const isProtocolTextLoaded = (): boolean => loaded;
